
  import { QDate, QIcon, QInput, QPopupProxy } from 'quasar'
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import { dateUtils } from '@parantion/components'
  import { isValid, parse } from 'date-fns'

  const { convertDateFormatToISO_8601 } = dateUtils

  @Component({
    components: { QDate, QInput, QIcon, QPopupProxy },
  })
  export default class DateFormField extends Vue {
    @Prop({ type: String, default: '', required: true }) value: string
    @Prop({ type: String, default: '' }) label: string
    @Prop({ type: Boolean, default: false }) filled: boolean;
    @Prop({ type: Boolean, default: false }) required: boolean;

    $refs: {
      qDateProxy: HTMLFormElement,
    }

    innerValue: string = ''
    shouldShowDatepicker: boolean = false

    get hintText () {
      return this.required ? this.$t('student.required.label') : ''
    }

    @Watch('value', { immediate: true })
    valueWatcher (newVal, oldVal) {
      this.innerValue = newVal ? convertDateFormatToISO_8601(newVal, 'dd-MM-yyyy') : ''
    }

    datePickerToggler() {
      this.shouldShowDatepicker = !this.shouldShowDatepicker
    }

    dateInputHandler (val) {
      this.$refs.qDateProxy.hide()
      this.valueEmitter(val)
    }

    inputHandler (val) {
      this.valueEmitter(val)
    }

    dateValidator (val) {
      const [, , year] = val.split('-')

      if (!year || year.length < 4) return false
      return isValid(parse(val, 'dd-MM-yyyy', new Date()))
    }

    valueEmitter (val) {
      this.innerValue = val
      if (this.dateValidator(val)) {
        this.$emit('input', convertDateFormatToISO_8601(parse(val, 'dd-MM-yyyy', new Date())))
      }
    }
  }
